$(document).ready(function () {

// Header Customer Service
$('.announcement-customer-service').on('mouseenter', function() {
  $(this).addClass('is-open');
}).on('mouseleave', function() {
  $(this).removeClass('is-open');
});

// Featured collection
$('.featured-collection--image').on('mouseenter', function() {
  $(this).addClass('is-active');
}).on('mouseleave', function() {
  $(this).removeClass('is-active');
});

// Drawer Close
$('.menu--drawer_close, .mobile-sidebar-logo .fa-xmark').click(function() {    
    $('summary.header__icon').click();
});

// Footer Menu Toggle (Mobile)
$(".footer-block__heading").click(function () {
    var $content = $(this).next('.footer-block__details-content, .footer-block__newsletter .contents');
    
    // Remove 'is-open' class from all headings
    $('.footer-block__heading').removeClass('is-open');
    
    if ($content.is(':visible')) {
        $content.slideUp();
    } else {
        // Close all open blocks
        $('.footer-block__details-content, .footer-block__newsletter .contents').slideUp();
        $content.slideDown();
        // Add 'is-open' class to the clicked heading
        $(this).addClass('is-open');
    }
});

// Size Guide Tabs
$('.guide-tabs li').click(function(){
    var index = $(this).data('index');
    $('.guide-tabs li').removeClass('is-active');
    $(this).addClass('is-active');

    $('.guide-tabs-one').removeClass('is-active');
    $('.guide-item-'+index).addClass('is-active');    
})

// Size Guide Modal PDP
$('.sizeChartbuttonforp').click(function() {    
    $('.guide-modal').css('display', 'flex').hide().fadeIn();
});

$('.guide-modal-close').click(function() {    
    $('.guide-modal').fadeOut(function() {
        $(this).css('display', 'none');
    });    
});


// Accordions PDP Desktop
$('.accord-title').click(function(){
    var indexx = $(this).data('index');
    $('.accord-title').removeClass('is-active');
    $(this).addClass('is-active');

    $('.accord-text').removeClass('is-active');
    $('.accord-'+indexx).addClass('is-active');    
})

// Accordions PDP Mobile
$(".pdp-accord-m-title").click(function () {
    var $contents = $(this).next('.pdp-accord-m-content');

    $('.pdp-accord-m-title').removeClass('is-open');
    
    if ($contents.is(':visible')) {
        $contents.slideUp();
    } else {        
        $('.pdp-accord-m-content').slideUp();
        $contents.slideDown();        
        $(this).addClass('is-open');
    }
});

$('.apply-promo-title').click(function() {
    $('.input-group.inputPromo').toggle();    
});

// Megamenu
$('[id^="menu-"]').each(function() {
  var menuId = $(this).attr('id'); // e.g. menu-products
  var megaId = menuId.replace('menu-', 'mega-'); // e.g. mega-products
  var $mega = $('#' + megaId);

  if ($mega.length) {
    $(this).append($mega);
  }
});

// onscroll addclass
$(window).on('scroll', function() {
  if ($(this).scrollTop() > 5) {
    $('.section-header').addClass('is-scroll-enabled');
  } else {
    $('.section-header').removeClass('is-scroll-enabled');
  }
});


});